import { useState } from 'react';
import { IOS_URL, ANDROID_URL } from '../../siteData';
import { usePlatform } from '../../siteHelpers';
import Icon from '../Icon/icon';
import BookWaitlist from '../BookWaitlist/bookWaitlist';
import logo from '../../assets/logo.svg';
import './links.scss';

// "Link in bio" page for the Instagram and TikTok profiles (issue #177). It lives at
// /links and is deliberately not linked from the main site; it is shared on its own.
// Visitors arrive on a phone, mostly from Instagram or TikTok, so the visitor's own
// app store comes first. Links open in a new tab, so this page stays open behind them.
const APP_STORE = { label: 'App Store', eyebrow: 'Get the app', href: IOS_URL, icon: 'apple' };
const GOOGLE_PLAY = { label: 'Google Play', eyebrow: 'Get the app', href: ANDROID_URL, icon: 'googlePlay' };

const OTHER_LINKS = [
  { label: 'YouTube', href: 'https://youtube.com/@thriillapp?feature=shared', icon: 'youtube' },
  { label: 'Instagram', href: 'https://www.instagram.com/thriillapp?igsh=dWlmbWR5NWhyYnhq', icon: 'instagram' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@thriill.com?_t=8pkNUYkvnpg&_r=1', icon: 'tiktok' },
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61558666558135', icon: 'facebook' },
  { label: 'Website', href: 'https://thriill.com', icon: 'thriill' },
  { label: 'Support us, if you like', eyebrow: 'Ko-fi', href: 'https://ko-fi.com/thriill', icon: 'kofi', kind: 'support' },
];

const Links = () => {
  const platform = usePlatform();
  const [copied, setCopied] = useState(false);
  const stores = platform === 'android' ? [GOOGLE_PLAY, APP_STORE] : [APP_STORE, GOOGLE_PLAY];

  const card = (link) => (
    <li key={link.href}>
      <a
        className={`links-card${link.kind ? ` is-${link.kind}` : ''}`}
        href={link.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className={`links-badge is-${link.icon}`}>
          {link.icon === 'thriill' ? <img src={logo} alt="" width="38" height="38" /> : <Icon name={link.icon} />}
        </span>
        <span className="links-body">
          {link.eyebrow && <span className="links-eyebrow">{link.eyebrow}</span>}
          <span className="links-title">{link.label}</span>
        </span>
        <span className="links-chev" aria-hidden="true">›</span>
      </a>
    </li>
  );

  const share = () => {
    const url = window.location.href;
    if (navigator.share) {
      navigator.share({ title: 'Thriill! Train Your Ear', url }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1800);
      }).catch(() => {});
    }
  };

  return (
    <div className="links-page">
      <header className="links-header">
        <a className="links-brand" href="https://thriill.com">
          <img src={logo} alt="" width="44" height="44" />
          <span>
            <span className="links-name">Thriill</span>
            <span className="links-tagline">Train your ear</span>
          </span>
        </a>
        <button className="links-share" type="button" onClick={share}>
          <span className="links-share-ring"><Icon name="share" /></span>
          <span className="links-share-label">{copied ? 'Copied' : 'Share'}</span>
        </button>
      </header>


      <ul className="links-list">
        {stores.map(card)}
        <li>
          <BookWaitlist />
        </li>
        {OTHER_LINKS.map(card)}
      </ul>

      <p className="links-footer">Thriill! Train Your Ear</p>
    </div>
  );
};

export default Links;
